import request from './request'

// 导出模板
export function exportInfoTemplate (data) {
  return request.get('en/exportInfo/downloadTemplet', data)
}
// 设备导入
export function importDevice (data) {
  return request.post('en/import/device', data, 'formdata')
}
// 设备导出
export function exportDevice (data) {
  return request.get('en/export/device', data)
}
// zone导入
export function importZone (data) {
  return request.post('en/import/zone', data, 'formdata')
}
// zone导出
export function exportZone (data) {
  return request.get('en/export/zone', data)
}
// 编程导入
export function importAdvance (data) {
  return request.post('en/import/advance', data, 'formdata')
}
// 编程导出
export function exportAdvance (data) {
  return request.get('en/export/advance', data)
}
// 下载中心列表
export function exportInfoList (data) {
  return request.get('en/exportInfo/list', data)
}
// 删除下载
export function deleteDownloadInfo (data) {
  return request.post('en/exportInfo/remove', data)
}
// 账号列表导出
export function exportUser (data) {
  return request.get('en/export/user', data)
}
